import type { CreateCustomerData } from '../schemas'
import { CREATE_STEPS, CREATE_STEPS_KIDS, CreateStepKey } from '../types'
import { isKidsAccount } from './isKids'

export const getFlowSteps = (
  data: Partial<CreateCustomerData>
): CreateStepKey[] => (isKidsAccount(data) ? CREATE_STEPS_KIDS : CREATE_STEPS)

/** Wizard steps, or a single step when opening an optional section from the overview. */
export const getModalSteps = (
  data: Partial<CreateCustomerData>,
  entryStep?: CreateStepKey
): CreateStepKey[] => {
  const flowSteps = getFlowSteps(data)
  if (!entryStep || flowSteps.includes(entryStep)) {
    return flowSteps
  }
  return [entryStep]
}
